import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

import { Badge, DefaultTooltip } from 'twyne-new.ui';

const propTypes = {
  item: PropTypes.object,
};

export default function ProfileProgressMetrics({ item }) {
  if (!item.value || !item.value.length) return null

  return <div className='flex gap-2'>
    <DefaultTooltip content='RPU for this profile'>
      <Badge color='accent' size='sm' variant='light'>
        rpu: <NumberFormat value={item.rpu || 0} displayType="text" thousandSeparator="," decimalSeparator="." prefix={'$ '} decimalScale={2} fixedDecimalScale={true} />
      </Badge>
    </DefaultTooltip>

    <DefaultTooltip content='Impressions for this profile'>
      <Badge color='neutral' size='sm' variant='light'>
        impressions: {item.impressions || 0}
      </Badge>
    </DefaultTooltip>
  </div>
}

ProfileProgressMetrics.propTypes = propTypes
ProfileProgressMetrics.defaultProps = {}
